<template>
  <!-- 底部link图标组件 -->
  <!-- <section class="data-section"> -->
  <div class="contact-us footer-Links">
    <p class="menu-title">
      Links
      <img class="fenge" src="../../assets/images/fenge.png" />
    </p>
    <div>
      <a
        v-for="(item, index) in list"
        :key="index"
        :href="item.link"
        target="_blank"
      >
        <img class="link-img" :src="`${filePreview}${item.cover}`" />
      </a>
    </div>
  </div>
  <!-- </section> -->
</template>

<script>
export default {
  name: "InfoCount",
  data() {
    return {
      filePreview: `${window._CONFIG["filePreview"]}?fileId=`,
      list: [],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let ucode = "c3cee896857c42dfbcae74bc06a9b442";
      let url = `${window._CONFIG["domianURL"]}xmu/index/getData/${ucode}?column=id&order=desc&pageNo=1&pageSize=999&superQueryMatchType=and`;
      this.$axios({
        method: "get",
        url: url,
      }).then((res) => {
        let data = res.data.result.records.slice(0,3);
        this.list = data;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.contact-us {
  font-size: 18px;
  color: #1e1e1e !important;
}

.menu-title {
  font-size: 30px;
  color: #003a7e;
}

.fenge {
  width: 194px !important;
}

.footer-list {
  margin: 0;

  li {
    list-style-type: none;
    text-indent: -34px;
    padding-left: 34px;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 22px;

    a {
      vertical-align: middle;
      color: #1e1e1e;
      text-decoration: none;
    }
  }
}

.footer-list li a:before {
  width: 15px;
  margin-right: 12px;
  background: #a4b9d1;
  display: inline-block;
  vertical-align: middle;
  content: "";
  height: 2px;
  transition: inherit;
}

.link-img {
  margin: 0 30px 26px 0;
  width: 70px;
}
</style>
